import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  updateButtonContainer: {
    marginLeft: 'auto',
  },
  dateField: {
    padding: theme.spacing(2.5, 5, 2.5, 5),
  },
}))
